import { PermissionActions } from '@/features/permissions/permissionActions.js'
import SuperAdminDummyRouter from '@/features/superAdmin/SuperAdminDummyRouter.vue'

export const termManagementRoutes = [
  {
    path: 'term-management',
    component: SuperAdminDummyRouter,
    meta: { permissionAction: PermissionActions.TermsAndConditionsView },
    children: [
      {
        path: '',
        component: () =>
          import('@/features/settingsManagement/termManagement/list/TermListView.vue'),
        meta: { permissionAction: PermissionActions.TermsAndConditionsView },
      },
      {
        path: ':termId',
        component: () =>
          import('@/features/settingsManagement/termManagement/edit/TermEditView.vue'),
        meta: { permissionAction: PermissionActions.TermsAndConditionsView },
      },
      {
        path: 'new',
        component: () =>
          import('@/features/settingsManagement/termManagement/edit/TermEditView.vue'),
        meta: { permissionAction: PermissionActions.TermsAndConditionsCreate },
      },
    ],
  },
]
